import React from 'react';
import PropTypes from 'prop-types';

const ButtonGroup = ({ childComponent, children }) => (
  <div className={`button-group d-flex border-1 border-color-grey--mid border-radius-s button-group--${childComponent}`}>
    {children}
  </div>
);

ButtonGroup.propTypes = {
  childComponent: PropTypes.string,
  children: PropTypes.array.isRequired,
};

export default ButtonGroup;



// WEBPACK FOOTER //
// ./library/app/components/Global/Buttons/ButtonGroup.js